/**
 * PlanChangeType
 * @export EnumSubscriptionType
 * @enum
 */
enum EnumSubscriptionType {
  Post,
  Patch,
}

export default EnumSubscriptionType
